import axios from "axios";
import MyContext from "MyContext";
import React, { useContext, useState } from "react";

const ChangePassword = () => {
     const { endPointUrl} = useContext(MyContext);
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!formData.newPassword || !formData.confirmPassword) {
      setError("All fields are required.");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    try {         
      const {status,message} = await axios.post(`${endPointUrl}/admin/changepassword`,{
        newPassword:formData.newPassword
      })

      if (status) {
        setSuccess("Password changed successfully!");
        setFormData({ newPassword: "", confirmPassword: "" });
      } else {
        setError(message || "Something went wrong.");
      }
    } catch (err) {
        console.log(err)
      setError("Server error. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 border rounded-lg shadow-md">
      <h3 className="text-2xl font-bold mb-4">Change Password</h3>

      {error && <p style={{color:"red"}} className="text-red-500 mb-3">{error}</p>}
      {success && <p style={{color:"green"}} className="text-green-500 mb-3">{success}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">New Password</label>
          <input
            type="password"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Enter new password"
          />
        </div>

        <div>
          <label className="block mb-1">Confirm Password</label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Confirm new password"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-black py-2 rounded hover:bg-blue-700"
        >
          Change Password
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
